import { ref } from 'vue';

export interface DialogLaunchPoint {
  x: number;
  y: number;
}

/**
 * 管理轻量浮窗的显隐状态与触发锚点。
 *
 * @returns 浮窗状态、触发点以及打开、更新和关闭方法
 */
export function useDialogLaunch() {
  // 浮窗是否可见。
  const visible = ref(false);
  // 浮窗当前连接的屏幕锚点。
  const launchPoint = ref<DialogLaunchPoint>({ x: 0, y: 0 });

  /**
   * 从指定屏幕坐标打开浮窗。
   *
   * @param point - 浮窗触发锚点
   */
  function open(point: DialogLaunchPoint): void {
    launchPoint.value = point;
    visible.value = true;
  }

  /**
   * 更新浮窗所连接的屏幕坐标。
   *
   * @param point - 新的浮窗触发锚点
   */
  function update(point: DialogLaunchPoint): void {
    if (launchPoint.value.x === point.x && launchPoint.value.y === point.y) return;
    launchPoint.value = point;
  }

  /**
   * 关闭浮窗。
   */
  function close(): void {
    visible.value = false;
  }

  return { visible, launchPoint, open, update, close };
}
